(function ($) {
  /**
   * Search-bar display/hide
   */

  let headerSearchSection = document.getElementById(
    "header__right__search--id"
  );
  let headerSearchIcon = document.getElementById(
    "header__search--button-icon-id"
  );
  let headerSearchInput = document.getElementById("search-input");
  let headerSearchForm = document.getElementById("header-rekai-search-bar");
  let headerMainMenu = document.getElementById("block-main-menu");
  let headerMainMobileMenu = document.getElementById("block-main-mobilemenu");
  let openMainMenu = document.getElementById("open-main-menu");
  let mobileMenuOpen = document.querySelector(".header.region.region-header");

  const searchBarDisplayHide = (event) => {
    if (
      event.type === "click" ||
      event.type === "touchstart" ||
      (event.type === "keydown" && (event.key === "Enter" || event.key === " "))
    ) {
      event.preventDefault();

      if (headerSearchForm.classList.contains("header__search--hidden")) {
        headerSearchForm.classList.remove("header__search--hidden");
        headerSearchInput.focus();

        headerSearchSection.classList.remove("header__search-visibility");
        mobileMenuOpen.classList.remove("mobile-menu-open");
        openMainMenu.classList.remove("menu-open");
        headerMainMenu.classList.remove("menu-open");
        headerMainMobileMenu.classList.remove("menu-open");

        headerSearchIcon.innerHTML =
          '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"></path> </g></svg>';
      } else {
        headerSearchIcon.innerHTML =
          '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="8" stroke="black" stroke-width="2"/><line x1="16" y1="16" x2="21" y2="21" stroke="black" stroke-width="2" stroke-linecap="round"/></svg>';

        headerSearchForm.classList.add("header__search--hidden");
      }
    }
  };

  if (headerSearchIcon) {
    headerSearchIcon.setAttribute("tabindex", "0");

    headerSearchIcon.addEventListener("click", searchBarDisplayHide);
    headerSearchIcon.addEventListener("touchstart", searchBarDisplayHide);
    headerSearchIcon.addEventListener("keydown", searchBarDisplayHide);
  }

  /**
   * Handle search-query parameter for search input field
   */
  const urlParams = new URLSearchParams(window.location.search);
  let searchQuery = urlParams.get("keys") || "";
  let searchQueryString = document.querySelectorAll('input[name="keys"]');
  searchQueryString.forEach((element) => {
    element.value = searchQuery;
  });

  /**
   * Adding search suggestion button as last-child in search results-list.
   */
  setTimeout(() => {
    let searchSuggestionsChild = document.querySelectorAll(
      ".rekai-dataset-1, .rekai-dataset-3"
    );

    if (searchSuggestionsChild.length > 0) {
      for (let i = 0; i < searchSuggestionsChild.length; i++) {
        let newSearchLink = document.createElement("input");

        newSearchLink.type = "submit";
        newSearchLink.value = "Visa fler";
        newSearchLink.classList.add(
          "rekai-suggestion",
          "rekai-suggestion-flera-mer",
          "search-page-normal"
        );
        searchSuggestionsChild[i].insertAdjacentElement(
          "afterend",
          newSearchLink
        );
      }
    }
  }, 1000); // Adding a delay to ensure the search results are loaded before adding the button.

  /**
   * Monitor selected language & hide search-option for all languages (other than Swedish).
   */

  /*   const htmlElement = document.documentElement;
  const observer = new MutationObserver((mutationsList) => {
  // MutationObserver to watch for changes to the lang attribute
  for (const mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "lang") {
        const newLang = htmlElement.lang;

        if (newLang === "sv") {
          headerSearchSection.style.display = "block";
        } else {
          headerSearchSection.style.display = "none";
        }
      }
    }

  observer.disconnect(); // Disconnect observer after the first change is detected. Can lead to performance issues.
    });

  const config = { attributes: true, attributeFilter: ["lang"] }; // Observe changes to the 'lang' attribute only.

  observer.observe(htmlElement, config); // Start observing */
})(jQuery);
